import { createInstance } from 'i18next';
import { findSiteByDomain } from '@zooplus/commons-lang';
import translations_bitiba_cs_CZ from '../locales/bitiba/cs_CZ.json.js';
import translations_bitiba_da_DK from '../locales/bitiba/da_DK.json.js';
import translations_bitiba_de_CH from '../locales/bitiba/de_CH.json.js';
import translations_bitiba_de_DE from '../locales/bitiba/de_DE.json.js';
import translations_bitiba_en_GB from '../locales/bitiba/en_GB.json.js';
import translations_bitiba_es_ES from '../locales/bitiba/es_ES.json.js';
import translations_bitiba_fi_FI from '../locales/bitiba/fi_FI.json.js';
import translations_bitiba_fr_BE from '../locales/bitiba/fr_BE.json.js';
import translations_bitiba_fr_FR from '../locales/bitiba/fr_FR.json.js';
import translations_bitiba_it_IT from '../locales/bitiba/it_IT.json.js';
import translations_bitiba_nl_NL from '../locales/bitiba/nl_NL.json.js';
import translations_bitiba_pl_PL from '../locales/bitiba/pl_PL.json.js';
import translations_bitiba_sv_SE from '../locales/bitiba/sv_SE.json.js';
import translations_zooplus_bg_BG from '../locales/zooplus/bg_BG.json.js';
import translations_zooplus_cs_CZ from '../locales/zooplus/cs_CZ.json.js';
import translations_zooplus_da_DK from '../locales/zooplus/da_DK.json.js';
import translations_zooplus_de_AT from '../locales/zooplus/de_AT.json.js';
import translations_zooplus_de_CH from '../locales/zooplus/de_CH.json.js';
import translations_zooplus_de_DE from '../locales/zooplus/de_DE.json.js';
import translations_zooplus_el_GR from '../locales/zooplus/el_GR.json.js';
import translations_zooplus_en from '../locales/zooplus/en.json.js';
import translations_zooplus_en_GB from '../locales/zooplus/en_GB.json.js';
import translations_zooplus_en_IE from '../locales/zooplus/en_IE.json.js';
import translations_zooplus_es_ES from '../locales/zooplus/es_ES.json.js';
import translations_zooplus_fi_FI from '../locales/zooplus/fi_FI.json.js';
import translations_zooplus_fr_BE from '../locales/zooplus/fr_BE.json.js';
import translations_zooplus_fr_CH from '../locales/zooplus/fr_CH.json.js';
import translations_zooplus_fr_FR from '../locales/zooplus/fr_FR.json.js';
import translations_zooplus_hr_HR from '../locales/zooplus/hr_HR.json.js';
import translations_zooplus_hu_HU from '../locales/zooplus/hu_HU.json.js';
import translations_zooplus_it_IT from '../locales/zooplus/it_IT.json.js';
import translations_zooplus_nb_NO from '../locales/zooplus/nb_NO.json.js';
import translations_zooplus_nl_NL from '../locales/zooplus/nl_NL.json.js';
import translations_zooplus_pl_PL from '../locales/zooplus/pl_PL.json.js';
import translations_zooplus_pt_PT from '../locales/zooplus/pt_PT.json.js';
import translations_zooplus_ro_RO from '../locales/zooplus/ro_RO.json.js';
import translations_zooplus_ru_RU from '../locales/zooplus/ru_RU.json.js';
import translations_zooplus_sk_SK from '../locales/zooplus/sk_SK.json.js';
import translations_zooplus_sl_SI from '../locales/zooplus/sl_SI.json.js';
import translations_zooplus_sv_SE from '../locales/zooplus/sv_SE.json.js';

const translations = {
    zooplus: {
        'bg-BG': translations_zooplus_bg_BG,
        'cs-CZ': translations_zooplus_cs_CZ,
        'da-DK': translations_zooplus_da_DK,
        'de-AT': translations_zooplus_de_AT,
        'de-CH': translations_zooplus_de_CH,
        'de-DE': translations_zooplus_de_DE,
        'el-GR': translations_zooplus_el_GR,
        en: translations_zooplus_en,
        'en-GB': translations_zooplus_en_GB,
        'en-IE': translations_zooplus_en_IE,
        'es-ES': translations_zooplus_es_ES,
        'fi-FI': translations_zooplus_fi_FI,
        'fr-BE': translations_zooplus_fr_BE,
        'fr-CH': translations_zooplus_fr_CH,
        'fr-FR': translations_zooplus_fr_FR,
        'hr-HR': translations_zooplus_hr_HR,
        'hu-HU': translations_zooplus_hu_HU,
        'it-IT': translations_zooplus_it_IT,
        'nl-NL': translations_zooplus_nl_NL,
        'nb-NO': translations_zooplus_nb_NO,
        'pl-PL': translations_zooplus_pl_PL,
        'pt-PT': translations_zooplus_pt_PT,
        'ro-RO': translations_zooplus_ro_RO,
        'ru-RU': translations_zooplus_ru_RU,
        'sk-SK': translations_zooplus_sk_SK,
        'sl-SI': translations_zooplus_sl_SI,
        'sv-SE': translations_zooplus_sv_SE,
    },
    bitiba: {
        'cs-CZ': translations_bitiba_cs_CZ,
        'da-DK': translations_bitiba_da_DK,
        'de-CH': translations_bitiba_de_CH,
        'de-DE': translations_bitiba_de_DE,
        'en-GB': translations_bitiba_en_GB,
        'es-ES': translations_bitiba_es_ES,
        'fi-FI': translations_bitiba_fi_FI,
        'fr-BE': translations_bitiba_fr_BE,
        'fr-FR': translations_bitiba_fr_FR,
        'it-IT': translations_bitiba_it_IT,
        'nl-NL': translations_bitiba_nl_NL,
        'pl-PL': translations_bitiba_pl_PL,
        'sv-SE': translations_bitiba_sv_SE,
    },
};
const initializeI18n = (domain, locale) => {
    return createI18nInstance(translations[findSiteByDomain(domain).realm][locale] ||
        translations.zooplus.en);
};
const createI18nInstance = (translation) => {
    const i18n = createInstance({
        lng: 'lang',
        resources: { lang: { translation } },
        react: { useSuspense: false },
        initImmediate: true,
        interpolation: { prefix: '{', suffix: '}', escapeValue: false },
    });
    i18n.init(); // no need to await thanks to {initImmediate: true}
    return i18n;
};

export { initializeI18n };
//# sourceMappingURL=i18nService.js.map
